import QRCode from 'qrcode.react'
import { saveAs } from 'file-saver'

export const DownloadableQRCode = ({ id, title, value }) => (
  <div className="qr-code-download">
    <button
      type="button"
      onClick={() => {
        const canvas = document.getElementById(`qr-${id}`) as HTMLCanvasElement
        canvas.toBlob((blob) => {
          saveAs(blob)
        })
      }}
    >
      Download QR Code
    </button>
    <QRCode
      style={{ height: 256, width: 256 }}
      id={`qr-${id}`}
      level="M"
      title={title}
      value={value}
      size={1024}
    />
  </div>
)

export const getOrigin = (tenantAlias: string): string => (
  tenantAlias ? `${window.location.protocol}//${tenantAlias}` : window.location.origin
)
